import { compose } from '@reduxjs/toolkit';
import { fetchAllUploadsReducer } from './fetchAllUploads';
import { fetchUploadByFileTypeReducer } from './fetchUploadByFileType';
import { uploadFileByFileTypeReducer } from './uploadFileByFileType';

export const extraReducers = compose(fetchAllUploadsReducer, fetchUploadByFileTypeReducer, uploadFileByFileTypeReducer);

export { fetchAllUploads } from './fetchAllUploads';
export { fetchUploadByFileType } from './fetchUploadByFileType';
export { uploadFileByFileType } from './uploadFileByFileType';
